import styled from 'styled-components'
import { Select as AntSelect, Divider as AntDivider, Flex as AntFlex } from 'antd'
import { BookOutlined as AntBookOutlined, PlusOutlined as AntPlusOutlined } from '@ant-design/icons'
import { COLORS, SPACING, TYPOGRAPHY, MEDIA, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for ProjectSelector
 * Replaces inline styles with reusable, semantic components
 */

// Container for project selector
export const ProjectSelectorContainer = styled(AntFlex)`
  &.ant-flex {
    min-width: 0;

    ${MEDIA.mobile} {
      flex: 1;
      max-width: 100%;
    }
  }
`

// Icon with secondary color - hidden on mobile
export const BookIcon = styled(AntBookOutlined)`
  color: ${COLORS.textSecondary};

  ${MEDIA.mobile} {
    display: none;
  }
`

// Secondary text label - hidden on mobile
export const ProjectLabel = styled.span`
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: ${COLORS.textSecondary};

  ${MEDIA.mobile} {
    display: none;
  }
`

// Project select dropdown - flexible width on mobile
export const ProjectSelect = styled(AntSelect<string>)`
  min-width: 200px;

  ${MEDIA.mobile} {
    min-width: 140px !important;
    width: auto !important;
    max-width: 300px;

    .ant-select-selector {
      padding: 0 8px !important;
    }

    .ant-select-selection-item {
      max-width: 260px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  ${MEDIA.smallMobile} {
    max-width: 220px;

    .ant-select-selection-item {
      max-width: 180px;
    }
  }
`

// Divider in dropdown menu
export const DropdownDivider = styled(AntDivider)`
  &.ant-divider {
    margin: ${SPACING.sm} 0;
  }
`

// Create new project option
export const CreateProjectOption = styled.div`
  padding: ${SPACING.xs} ${SPACING.sm};
  cursor: pointer;
`

// Plus icon with right margin
export const PlusIcon = styled(AntPlusOutlined)`
  margin-right: ${SPACING.sm};
`

// Archived status chip
export const ArchivedChip = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: center;
  gap: 6px;
  height: 32px;
  padding: 0 ${SPACING.md};
  margin-left: ${SPACING.sm};
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.extraBold};
  letter-spacing: 0.3px;
  color: ${COLORS.textSecondary};
  background-color: ${COLORS.bgHover};
  border: 1px solid ${COLORS.borderLight};
  border-radius: 4px;
`

// Project option label with icon support
export const ProjectOptionLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${SPACING.xs};
`

// Archived icon in dropdown option
export const ArchivedIcon = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${COLORS.textSecondary};
  opacity: 0.7;
`
